import Tippy from 'tippy.js';

const DEFAULT_OPTION = {
    arrow: true,
    placement: 'top',
    trigger: 'mouseenter',
    theme: 'dark',
    boundary: 'window',
};

export default function (el, {value}) {
    !!el.lv_tippy && el.lv_tippy.destroy();
    if (LinkUtils.typeOf(value) === 'object') {
        const {content, arrow = false, placement = 'bottom', trigger = 'mouseenter', theme = 'dark', boundary = 'window', disabled = false} = value
        !!content && !disabled && (el.lv_tippy = Tippy(el, {content, arrow, placement, trigger, theme, boundary}))
    }
    else if (LinkUtils.typeOf(value) === 'string') {
        const content = value
        !!content && (el.lv_tippy = Tippy(el, {content, ...DEFAULT_OPTION}))
    }
}
